// English: the reference language. Every key used by PageFlow must exist here.
export default {
    // Canvas and empty page
    'canvas.title': 'Page content',
    'canvas.loading': 'Loading the editor…',
    'empty.title': 'Start your page',
    'empty.text': 'Drag a block or a ready-made section here, or click one to add it.',
    'empty.sections': 'Browse sections',
    'empty.blocks': 'Add a block',

    // Panels and tabs
    'panel.insert': 'Add',
    'panel.settings': 'Settings',
    'panel.content': 'Content',
    'panel.layout': 'Layout',
    'panel.style': 'Style',
    'panel.visibility': 'Visibility',
    'panel.advanced': 'Advanced',
    'tab.blocks': 'Blocks',
    'tab.sections': 'Sections',
    'tab.layers': 'Layers',
    'category.layout': 'Layout',
    'category.basic': 'Basic',
    'category.media': 'Media',
    'category.components': 'Components',
    'category.advanced': 'Advanced',
    'palette.hint': 'Drag into the page, or click to add',
    'palette.none': 'No block matches your search.',
    'sections.intro': 'Drag a section into the page, or click to add it. Every part stays editable.',
    'layers.empty': 'The page is empty.',
    'inspector.empty': 'Select a block in the page to edit its content and style.',
    'inspector.path': 'Position in the page',

    // Devices
    'device.label': 'Preview size',
    'device.desktop': 'Desktop',
    'device.tablet': 'Tablet',
    'device.mobile': 'Phone',

    // Actions
    'action.undo': 'Undo',
    'action.redo': 'Redo',
    'action.guides': 'Show the outlines of blocks',
    'action.preview': 'Preview',
    'action.code': 'Edit the code',
    'action.copyCode': 'Copy the code',
    'action.fullscreen': 'Full screen',
    'action.selectParent': 'Select the parent block',
    'action.move': 'Drag to move',
    'action.moveUp': 'Move up',
    'action.moveDown': 'Move down',
    'action.duplicate': 'Duplicate',
    'action.remove': 'Delete',
    'action.close': 'Close',
    'action.apply': 'Apply',
    'action.cancel': 'Cancel',
    'action.clear': 'Clear',
    'action.search': 'Search',
    'action.searchBlocks': 'Search blocks…',
    'action.addColumn': 'Add a column',
    'action.equalize': 'Equal widths',
    'action.addButton': 'Add a button',
    'action.addItem': 'Add an item',
    'action.resizeColumns': 'Drag to resize the columns',

    'category.saved': 'Saved',
    'action.saveBlock': 'Save as a reusable block',
    'action.save': 'Save',
    'action.restore': 'Restore',
    'saved.name': 'Name of the block',
    'saved.help': 'The block and everything inside it will be offered in Blocks › Saved, for this page and the next ones.',
    'saved.done': 'Block saved: find it in Blocks › Saved.',
    'saved.remove': 'Remove this saved block',
    'notice.draftFound': 'Changes made on {date} were not saved.',
    'error.storage': 'The browser refused to keep this block (storage full or disabled).',
    // Shortcuts
    'shortcut.undo': 'undo',
    'shortcut.duplicate': 'duplicate',
    'shortcut.move': 'move up or down',
    'shortcut.remove': 'delete',
    'shortcut.parent': 'select the parent',
    'shortcut.edit': 'edit the text',

    // Blocks
    'block.container': 'Container',
    'block.containerFluid': 'Full width',
    'block.box': 'Box',
    'block.row': 'Row',
    'block.col': 'Column',
    'block.heading': 'Heading',
    'block.text': 'Text',
    'block.quote': 'Quote',
    'block.list': 'List',
    'block.table': 'Table',
    'block.button': 'Button',
    'block.separator': 'Separator',
    'block.spacer': 'Spacer',
    'block.icon': 'Icon',
    'block.html': 'HTML',
    'block.image': 'Image',
    'block.video': 'Video',
    'block.embed': 'Embed',
    'block.map': 'Map',
    'block.card': 'Card',
    'block.accordion': 'Accordion',
    'preset.cols1': '1 column',
    'preset.cols2': '2 columns',
    'preset.cols3': '3 columns',
    'preset.cols4': '4 columns',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 columns',

    // Placeholders of new blocks
    'placeholder.heading': 'Your heading',
    'placeholder.text': 'Write your text here. Select words to make them bold, italic or a link.',
    'placeholder.quote': 'A great quote, short and memorable.',
    'placeholder.author': 'Author name',
    'placeholder.item': 'Item',
    'placeholder.column': 'Column',
    'placeholder.button': 'Click here',
    'placeholder.readMore': 'Read more',
    'placeholder.caption': 'Caption of the image',
    'placeholder.cardTitle': 'Card title',
    'placeholder.cardText': 'A short description that makes people want to know more.',
    'placeholder.question': 'Question',
    'placeholder.answer': 'The answer, in a few clear sentences.',
    'placeholder.html': 'Your HTML code',
    'placeholder.address': 'Eiffel Tower, Paris',

    // Fields
    'field.width': 'Width',
    'field.tag': 'HTML tag',
    'field.gutters': 'Space between columns',
    'field.justify': 'Horizontal alignment',
    'field.alignItems': 'Vertical alignment',
    'field.alignSelf': 'Vertical alignment in the row',
    'field.columnWidth': 'Width by screen size',
    'field.level': 'Level',
    'field.size': 'Size',
    'field.thickness': 'Thickness',
    'field.opacity': 'Opacity',
    'field.height': 'Height',
    'field.icon': 'Icon',
    'field.filled': 'Filled',
    'field.image': 'Image',
    'field.alt': 'Alternative text',
    'field.link': 'Link',
    'field.newTab': 'Open in a new tab',
    'field.caption': 'Caption',
    'field.align': 'Alignment',
    'field.ratio': 'Proportions',
    'field.corners': 'Corners',
    'field.shadow': 'Shadow',
    'field.videoUrl': 'Video',
    'field.controls': 'Show the controls',
    'field.autoplay': 'Autoplay (muted)',
    'field.loop': 'Loop',
    'field.muted': 'Muted',
    'field.url': 'Address (URL)',
    'field.address': 'Address',
    'field.zoom': 'Zoom',
    'field.showImage': 'Show an image',
    'field.titleLevel': 'Title level',
    'field.showButton': 'Show a button',
    'field.firstOpen': 'First item open',
    'field.items': 'Items',
    'field.question': 'Question',
    'field.text': 'Text',
    'field.style': 'Style',
    'field.code': 'HTML code',
    'field.textAlign': 'Text alignment',
    'field.spacing': 'Spacing',
    'field.margin': 'Margin',
    'field.padding': 'Padding',
    'field.background': 'Background',
    'field.backgroundImage': 'Background image',
    'field.textColor': 'Text color',
    'field.border': 'Border',
    'field.showOn': 'Show on',
    'field.id': 'Anchor (ID)',
    'field.classes': 'CSS classes',
    'field.inlineStyle': 'Inline style',
    'side.t': 'top',
    'side.b': 'bottom',
    'side.s': 'left',
    'side.e': 'right',

    // Help texts
    'help.alt': 'Describes the image for people who cannot see it and for search engines.',
    'help.video': 'A YouTube or Vimeo link, or the address of an MP4 file.',
    'help.embed': 'The address of a page that accepts to be embedded (a form, a calendar…).',
    'help.columnWidth': 'Phones first: an empty size uses the one of the smaller screen, shown in grey.',
    'help.visibility': 'Untick a size to hide the block on those screens.',
    'help.id': 'Lets a link point to this block: #anchor.',
    'help.classes': 'Classes of your theme or of Bootstrap, separated by spaces.',
    'help.accordion': 'Click a question or an answer in the page to edit its text.',
    'help.html': 'Scripts and event attributes are removed for safety.',

    // Options
    'option.default': 'Default',
    'option.none': 'None',
    'option.auto': 'Auto',
    'option.fill': 'Fill',
    'option.inherit': 'Inherit',
    'option.custom': 'Custom color',
    'option.boxed': 'Centered',
    'option.fullWidth': 'Full width',
    'option.start': 'Left',
    'option.center': 'Center',
    'option.end': 'Right',
    'option.between': 'Spread',
    'option.top': 'Top',
    'option.middle': 'Middle',
    'option.bottom': 'Bottom',
    'option.wrapLeft': 'Left, text around',
    'option.wrapRight': 'Right, text around',
    'option.original': 'Original',
    'option.square': 'Square',
    'option.rounded': 'Rounded',
    'option.pill': 'Pill',
    'option.circle': 'Circle',
    'option.small': 'Small',
    'option.medium': 'Medium',
    'option.large': 'Large',
    'button.primary': 'Primary',
    'button.outline-primary': 'Primary, outline',
    'button.secondary': 'Secondary',
    'button.outline-secondary': 'Secondary, outline',
    'button.success': 'Success',
    'button.outline-success': 'Success, outline',
    'button.danger': 'Danger',
    'button.outline-danger': 'Danger, outline',
    'button.warning': 'Warning',
    'button.outline-warning': 'Warning, outline',
    'button.info': 'Info',
    'button.outline-info': 'Info, outline',
    'button.light': 'Light',
    'button.outline-light': 'Light, outline',
    'button.dark': 'Dark',
    'button.outline-dark': 'Dark, outline',
    'button.link': 'Link',

    // Text editor
    'rte.toolbar': 'Text formatting',
    'rte.format': 'Paragraph style',
    'rte.paragraph': 'Paragraph',
    'rte.lead': 'Lead paragraph',
    'rte.small': 'Small text',
    'rte.table': 'Table…',
    'rte.rowAbove': 'Insert a row above',
    'rte.rowBelow': 'Insert a row below',
    'rte.colLeft': 'Insert a column left',
    'rte.colRight': 'Insert a column right',
    'rte.deleteRow': 'Delete the row',
    'rte.deleteCol': 'Delete the column',
    'rte.deleteTable': 'Delete the table',
    'rte.heading': 'Heading {n}',
    'rte.quote': 'Quote',
    'rte.code': 'Code',
    'rte.bold': 'Bold (Ctrl+B)',
    'rte.italic': 'Italic (Ctrl+I)',
    'rte.underline': 'Underline (Ctrl+U)',
    'rte.strike': 'Strikethrough',
    'rte.link': 'Link (Ctrl+K)',
    'rte.unlink': 'Remove the link',
    'rte.bulletList': 'Bulleted list',
    'rte.numberedList': 'Numbered list',
    'rte.alignLeft': 'Align left',
    'rte.alignCenter': 'Center',
    'rte.alignRight': 'Align right',
    'rte.justify': 'Justify',
    'rte.clear': 'Clear the formatting',

    // Media
    'media.upload': 'Upload',
    'media.library': 'Choose',
    'media.urlOnly': 'Paste the address of the file. Sending files from the computer needs an upload address (uploadUrl option).',
    'media.embedded': 'Image stored in the page',

    // Code
    'code.title': 'HTML code of the page',
    'code.help': 'Edit the code, then apply: PageFlow finds its blocks again. Scripts are removed.',

    // Notices and errors
    'notice.copied': 'Code copied to the clipboard',
    'notice.noGrid': 'The styles of the site did not load in the editor: a simple grid is used meanwhile. Check the canvasStyles option.',
    'notice.codeApplied': 'Code applied',
    'notice.cannotInsert': 'This block cannot go here. Select a column or a container first.',
    'error.copy': 'The code could not be copied. Select it in the code view instead.',
    'error.fileType': 'This type of file is not accepted here.',
    'error.fileSize': 'This file is too large (maximum {size} MB).',
    'error.upload': 'The file could not be uploaded.',
    'error.noUpload': 'No upload address is set: files of the computer cannot be sent. Paste the address of the file instead (developers: uploadUrl option, PHP handler included).',

    // Sections
    'sec.heroSplit': 'Hero with image',
    'sec.heroSplitDesc': 'Title, text and buttons next to a picture.',
    'sec.heroCenter': 'Centered hero',
    'sec.heroCenterDesc': 'A big centered message on a light band.',
    'sec.features': 'Features',
    'sec.featuresDesc': 'Three strong points with icons.',
    'sec.imageText': 'Image and text',
    'sec.imageTextDesc': 'A picture beside a text and a list.',
    'sec.cta': 'Call to action',
    'sec.ctaDesc': 'A colored band with one clear button.',
    'sec.cards': 'Cards',
    'sec.cardsDesc': 'Three articles, products or services.',
    'sec.testimonials': 'Testimonials',
    'sec.testimonialsDesc': 'What your clients say about you.',
    'sec.pricing': 'Pricing',
    'sec.pricingDesc': 'Three plans side by side.',
    'sec.faq': 'FAQ',
    'sec.faqDesc': 'Questions and answers that open on click.',
    'sec.stats': 'Key figures',
    'sec.statsDesc': 'Four numbers that build trust.',
    'sec.team': 'Team',
    'sec.teamDesc': 'Portraits with names and roles.',
    'sec.contact': 'Contact',
    'sec.contactDesc': 'Address, phone and e-mail beside a map.',
    'sec.gallery': 'Gallery',
    'sec.galleryDesc': 'Six pictures in a grid.',
    'sec.heroTitle': 'Build beautiful pages in minutes',
    'sec.heroText': 'Drag, drop and type: your page is ready, responsive and clean, without writing a single line of code.',
    'sec.getStarted': 'Get started',
    'sec.learnMore': 'Learn more',
    'sec.contactUs': 'Contact us',
    'sec.imageAlt': 'Picture',
    'sec.centerTitle': 'Everything you need, nothing you don’t',
    'sec.centerText': 'A simple promise that tells your visitors why they are in the right place.',
    'sec.featuresTitle': 'Why people choose us',
    'sec.featuresText': 'Three good reasons, explained in a few words.',
    'sec.feature1': 'Fast',
    'sec.feature2': 'Reliable',
    'sec.feature3': 'Made for phones',
    'sec.featureText': 'Describe this strong point in one or two sentences that speak to your visitors.',
    'sec.imageTextTitle': 'Tell your story',
    'sec.imageTextText': 'Explain what you do and how you help, in the words of your clients.',
    'sec.point1': 'A first benefit',
    'sec.point2': 'A second benefit',
    'sec.point3': 'A third benefit',
    'sec.ctaTitle': 'Ready to start?',
    'sec.ctaText': 'Join the people who already trust us. It only takes a minute.',
    'sec.cardsTitle': 'Latest news',
    'sec.cardTitle': 'A card title',
    'sec.cardText': 'A short summary that makes people want to read more.',
    'sec.readMore': 'Read more',
    'sec.testimonialsTitle': 'What our clients say',
    'sec.quote1': 'Simple, fast and beautiful. We rebuilt our whole site in a weekend.',
    'sec.quote2': 'The support answered within the hour. I recommend them without hesitation.',
    'sec.quote3': 'Our visitors stay longer and contact us more often since the new pages.',
    'sec.name1': 'Emma Lawson',
    'sec.name2': 'Lucas Martin',
    'sec.name3': 'Sofia Rossi',
    'sec.role1': 'Founder, Studio North',
    'sec.role2': 'Manager, Blue Harbor',
    'sec.role3': 'Director, Atelier Verde',
    'sec.pricingTitle': 'Simple pricing',
    'sec.pricingText': 'No hidden fees. Change or cancel at any time.',
    'sec.plan1': 'Starter',
    'sec.plan2': 'Professional',
    'sec.plan3': 'Business',
    'sec.month': 'month',
    'sec.benefit1': 'A first benefit',
    'sec.benefit2': 'A second benefit',
    'sec.benefit3': 'A third benefit',
    'sec.choose': 'Choose this plan',
    'sec.faqTitle': 'Frequently asked questions',
    'sec.question1': 'How do I get started?',
    'sec.answer1': 'Choose a plan, create your account and follow the guide: it takes a few minutes.',
    'sec.question2': 'Can I change my plan later?',
    'sec.answer2': 'Yes, at any time. The difference is calculated for you.',
    'sec.question3': 'Do you offer support?',
    'sec.answer3': 'Our team answers by e-mail every working day.',
    'sec.question4': 'Is my data safe?',
    'sec.answer4': 'Your data is stored securely and never shared.',
    'sec.stat1': 'happy clients',
    'sec.stat2': 'satisfaction',
    'sec.stat3': 'support',
    'sec.stat4': 'countries',
    'sec.teamTitle': 'Meet the team',
    'sec.member': 'Team member',
    'sec.jobTitle': 'Job title',
    'sec.contactTitle': 'Get in touch',
    'sec.contactText': 'We would love to hear from you. Write to us or come and see us.',
    'sec.addressLabel': 'Address',
    'sec.address': '5 Avenue Anatole France, 75007 Paris',
    'sec.phoneLabel': 'Phone',
    'sec.emailLabel': 'E-mail',
    'sec.galleryTitle': 'Gallery',
};
